"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MyEvent_1 = __importDefault(require("./MyEvent"));
/* eslint-disable @typescript-eslint/no-unused-vars */
class AudioElInstance {
    constructor(src) {
        this._loaded = false;
        this.onload = new MyEvent_1.default();
        this.onloaderr = new MyEvent_1.default();
        this.onplay = new MyEvent_1.default();
        this.onpause = new MyEvent_1.default();
        this.onseek = new MyEvent_1.default();
        this.onend = new MyEvent_1.default();
        this.el = document.createElement("audio");
        this.el.oncanplaythrough = e => {
            this.el.oncanplaythrough = null;
            this._loaded = true;
            this.onload.dispatch();
        };
        this.el.onerror = e => this.onloaderr.dispatch(e);
        this.el.preservesPitch = true;
        this.el.onended = e => {
            this.onend.dispatch();
            this.el.currentTime = 0;
        };
        this.el.src = src;
        this.el.load();
    }
    get loaded() {
        return this._loaded;
    }
    get duration() {
        return this.el.duration;
    }
    get volume() {
        return this.el.volume;
    }
    set volume(v) {
        this.el.volume = v;
    }
    get position() {
        return this.el.currentTime;
    }
    play(delay = 0) {
        this.el.play();
        this.onplay.dispatch();
        return this;
    }
    stop(delay = 0) {
        this.el.pause();
        this.el.currentTime = 0;
        this.onend.dispatch();
        return this;
    }
    pause(delay = 0) {
        this.el.pause();
        this.onpause.dispatch();
        return this;
    }
    seek(position) {
        this.el.currentTime = position;
        this.onseek.dispatch();
        return this;
    }
    get rate() {
        return this.el.playbackRate;
    }
    setRate(rate) {
        rate = Math.max(0.25, Math.min(4, rate));
        this.el.playbackRate = rate;
        return this;
    }
}
exports.default = AudioElInstance;
//# sourceMappingURL=AudioElInstance.js.map